<template>
  <div class="publish--page">
    <div class="title-box">
      <van-tabs @change="handleTabChange">
        <van-tab title="发布文章"></van-tab>
        <van-tab title="发布视频"></van-tab>
      </van-tabs>
      <span class="close-btn text-lighter" @click="goBack">
        <van-icon name="cross" />
      </span>
    </div>
    <van-field
      class="article-title"
      v-model="form.Title"
      :maxlength="titleMaxLength"
      placeholder="请输入标题"
    >
      <template slot="right-icon">
        <span class="text-small">{{`${form.Title.length}/${titleMaxLength}`}}</span>
      </template>
    </van-field>
    <div class="md-editor">
      <van-field v-model="form.Content" :autosize="{minHeight: 220}" type="textarea" placeholder="请输入内容" />
      <div class="w">
        <previewImg
          @clear="handleClear(index)"
          class="content-img"
          v-for="(imgsrc, index) in imgList"
          :key="index"
          :imgUrl="imgsrc"
        />
      </div>
    </div>
    <div class="upload-btn-box row-flex-base">
      <upLoad
        v-if="form.Type === 2"
        v-model="form.VideoUrl"
        class="marr-10"
        :mold="videoMold"
        showProgress
      >
        <div slot="input" class="upload-btn" :class="{loaded: form.VideoUrl !== ''}">
          <div>{{form.VideoUrl === ''? '视频': '完成'}}</div>
        </div>
      </upLoad>
      <upLoad @resultUrlList="handleUpImg">
        <div slot="input" class="upload-btn">
          <div>+图片</div>
        </div>
      </upLoad>
    </div>
    <van-cell
      title="选择频道"
      is-link
      @click="goToPage({ path: '/article/chooseCategory', query: { ids: form.CategoryIds }})"
    >
      <div class="ellipsis" v-if="currCateNames.length">{{getStr(currCateNames)}}</div>
    </van-cell>
    <van-cell
      title="标签设置"
      is-link
      @click="goToPage({ path: '/article/chooseTags', query: { ids: currTagIds }})"
    >
      <div class="ellipsis" v-if="form.Tags.length">{{getStr(form.Tags)}}</div>
    </van-cell>
    <!-- <van-cell title="付费阅读" v-if="userType === 6">
      <template>
        <div class="flex-rev">
          <van-checkbox v-model="isPay" ref="checkboxes"/>
        </div>
      </template>
    </van-cell>-->
    <!-- <van-cell class="md-cell" title="付款金额" v-if="isPay">
      <div class="border-input">
        <input class="input" v-model="form.Price" type="number">
        <span class="plus">元</span>
      </div>
    </van-cell>-->
    <!-- <van-cell>
      <template slot="title">
        <div class="title">试看内容</div>
        <div v-if="form.Type === 1" class="editor">
          <van-field
            v-validate="'required'"
            data-vv-as="试看内容"
            name="TrialContent"
            v-model="form.TrialContent"
            type="textarea"
            placeholder="请输入内容"
          />
        </div>
        <upLoad v-else v-model="form.TrialContent" class="marr-10" :mold='videoMold'>
          <div slot="input" class="upload-btn">
            <div>{{form.TrialContent === ''? '视频': '完成'}}</div>
          </div>
        </upLoad>
      </template>
    </van-cell>-->
    <van-cell>
      <template slot="title">
        <div class="text-c">
          <van-button size="large" class="submit-button" type="danger" @click="submit">确定发布</van-button>
        </div>
      </template>
    </van-cell>
  </div>
</template>

<script>
import upLoad from "@/components/common/upLoad.vue";
import commonMix from "@/mixins/commonMix.js";
import publishTagServices from '@/services/publishTagServices'
import previewImg from "@/components/common/previewImg.vue";
import { Cms } from "@/api";
export default {
  name: "publish",
  mixins: [commonMix],
  components: { upLoad, previewImg },
  data() {
    return {
      isPay: false,
      userType: this.$mdUtils.getUserInfo("Type"),
      currCateNames: [],
      currTagIds: [],
      titleMaxLength: 30,
      form: {
        "Type": 1,
        "Title": "",
        "Content": "",
        "CoverImage": "",
        "CategoryIds": [],
        "Tags": [],
        "Free": true,
        "Price": 0,
        "TrialContent": "",
        TrialDuration: 0,
        "UserId": this.$mdUtils.getUserInfo("Id"),
        "Code": "123",
        "PublishTiming": false,
        PublishDate: '',
        "Status": 2,
        IsProduct: false,
        VideoUrl: '',
        VideoDuration: 0,
      },
      ruls: {
        Title: {
          message: "请输入标题"
        },
        Content: {
          message: "请输入内容"
        },
        // TrialContent: {
        //   validator: this.validTrialContent()
        // },
        CoverImage: {
          message: "请选择并上传封面图"
        },
        Price: {
          validator: (data, cb) => {
            if (this.isPay) {
              if (Number(data) <= 0) {
                cb("请输入价格");
              }
            }
          }
        },
        VideoUrl: {
          validator: this.validVideoFac("请上传视频链接")
        },
        CategoryIds: {
          message: "请选择频道",
          type: "array"
        },
        Tags: {
          message: "请选择标签",
          type: "array"
        }
      },
      defaultForm: {},
      videoMold: {
        type: ["video/mp4", "video/avi"],
        accept: "video/mp4,video/avi",
        tips: "只能上传 mp4/avi 文件，且不超过 150M",
        sizeError: "上传图片大小不能超过 150M!",
        moldError: "上传图片只能为 mp4/avi 格式!",
        isSize: function(size) {
          return size / 1024 / 1024 < 150;
        }
      },
      imgList: []
    };
  },
  beforeCreate() {
    let userId = this.$mdUtils.getUserInfo("Id");
    if (!userId) {
      this.$mdUtils.wxLogOnAction();
    }
  },
  created() {
    // 保存默认数据
    this.defaultForm = this.$mdUtils.clone(this.form);
  },
  watch: {
    isPay(val) {
      this.form.Free = !val;
    },
    '$route': {
      handler: function () {
        this.getCategory()
        this.getTags()
      },
      immediate: true
    }
  },
  methods: {
    handleClear(i) {
      this.imgList.splice(i, 1);
    },
    handleTabChange(val) {
      this.form.Type = val + 1;
      this.form.TrialContent = "";
    },
    getStr(arr) {
      return arr.join("/").replace(/(.*)\/$/, "$1");
    },
    getCategory() { 
      let data = publishTagServices.getCategorys()
      this.currCateNames = data.currCateNames;
      this.form.CategoryIds = data.currCategory.map(c => c.Id);
    },
    getTags() {
      let data = publishTagServices.getTags()
      this.form.Tags = data.currTagNames;
      this.currTagIds = data.currTags.map(t => t.Id);
    },
    async submit() {
      
      let data = JSON.parse(JSON.stringify(this.form));
      let str = data.Content
      str = str.replace(/\n/g,'<br>')
      str = str.replace(/\s/g, '&nbsp;')
      data.Content = str;
      if (this.imgList.length) {
        data.CoverImage = this.imgList[0];
      }
      let isValid = await this.$valid.handleValid(this.ruls, data);

      if (!isValid) return;
      this.makeContentImg(data);
      let articleId = await this.$api(Cms.InsertArticle, data);
      this.$tips.success("上传成功");
      // let type = data.Type
      this.form = this.defaultForm;
      this.currCateNames = [];
      this.imgList = [];
      this.$router.replace({
        name: "detail",
        params: { id: articleId },
        query: { id: articleId, backUrl: "home" }
      });

      // this.$router.push({ name: 'articleList', params: { title: type == 1 ? 'article' : 'video' } })
    },
    clearForm() {},
    makeContentImg(data) {
      let imgStr = this.imgList.reduce((total, img) => {
        total += `<img src="${img}" alt="" />`;
        return total;
      }, "");

      data.Content += imgStr;
    },
    validTrialContent() {
      return (data, cb) => {
        if (this.form.Type == 1 && !data) {
          cb("请输入试看内容");
        } else if (this.form.Type == 2 && !data) {
          cb("请上传试看片段");
        } else {
          cb();
        }
      };
    },
    validVideoFac(msg) {
      return (data, cb) => {
        if (this.form.Type == 2 && !data) {
          cb(msg);
        } else {
          cb();
        }
      };
    },
    handleUpImg(file) {
      let src = file.baseUrl;
      this.imgList.push(src);
    }
  }
};
</script>

<style lang="scss">
.publish--page {
  .md-editor {
    .van-cell:not(:last-child)::after {
      display: none;
    }
  }
}
</style>


<style scoped lang="scss">
.publish--page {
  .article-title {
    font-size: 16px;
    font-weight: bold;
  }
  .upload-btn {
    width: 60px;
    height: 60px;
    line-height: 60px;
    border: 1px solid $gray;
    font-weight: blod;
    font-size: 14px;
    text-align: center;
    &.loaded {
      background: $red;
      color: #fff;
    }
    img {
      width: inherit;
      height: inherit;
    }
  }

  .submit-button {
    width: 300px;
    line-height: 50px;
  }
  .upload-btn-box {
    padding: 10px 0;
    margin: 0 20px;
    border-bottom: 1px solid #F2F2F2;
  }
  .title-box {
    position: relative;
    padding: 0 44px;

    .close-btn {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 100;
      width: 44px;
      text-align: center;
      line-height: 44px;
    }
  }
  .content-img {
    text-align: center;
    max-width: 100%;
    margin: 10px 0;
  }
  .md-editor {
    min-height: 220px;
  }
}
</style>
